import _regenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import TopNav from '@/components/TopNav';
import Hamburger from '@/components/Hamburger';
// import ThemePicker from '@/components/ThemePicker'
import Screenfull from '@/components/Screenfull';
// import SizeSelect from '@/components/SizeSelect'
import Search from '@/components/HeaderSearch';
import ChangePassword from '@/components/ChangePassword';
import AiChat from '@/components/AiChat';
import ImChat from '@/components/ImChat';
import { isClient, isNotClient } from '@/utils/permission';
import { hasAiPermission } from '@/utils/aiPermissions';
export default {
  components: {
    Breadcrumb: Breadcrumb,
    TopNav: TopNav,
    Hamburger: Hamburger,
    // ThemePicker,
    Screenfull: Screenfull,
    // SizeSelect,
    Search: Search,
    ChangePassword: ChangePassword,
    AiChat: AiChat,
    ImChat: ImChat
  },
  data: function data() {
    return {
      imChatVisible: false,
      aiChatVisible: false,
      uiPreferenceVisible: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['sidebar', 'avatar', 'name', 'device'])), {}, {
    setting: {
      get: function get() {
        return this.$store.state.settings.showSettings;
      },
      set: function set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        });
      }
    },
    topNav: {
      get: function get() {
        return this.$store.state.settings.topNav;
      }
    },
    filterOverlay: {
      get: function get() {
        return this.$store.state.settings.filterOverlay;
      },
      set: function set(value) {
        this.$store.dispatch('settings/changeUserPreference', {
          key: 'filterOverlay',
          value: value
        });
      }
    },
    // AI 对话按钮是否显示（排除 caky 客户）
    showAiChat: function showAiChat() {
      return isNotClient(['caky']) && hasAiPermission('assistantAccess');
    },
    // IM 消息按钮是否显示（排除 caky 客户）
    showImChat: function showImChat() {
      return isNotClient(['caky']);
    },
    imUnreadCount: function imUnreadCount() {
      var _this$$store$state$ch;
      return ((_this$$store$state$ch = this.$store.state.chat) === null || _this$$store$state$ch === void 0 ? void 0 : _this$$store$state$ch.unreadCount) || 0;
    }
  }),
  mounted: function mounted() {
    // 页面刷新/初次加载时，预先拉取一次对话列表以获取总未读数
    if (this.showImChat) {
      this.$store.dispatch('chat/loadChats');
    }
  },
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function logout() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return _this.$confirm('确定注销并退出系统吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              });
            case 1:
              _context.n = 2;
              return _this.$store.dispatch('user/logout');
            case 2:
              _context.n = 3;
              return _this.$router.replace("/login?redirect=".concat(_this.$route.fullPath));
            case 3:
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[0, 4]]);
      }))();
    },
    themeChange: function themeChange(val) {
      this.$store.dispatch('settings/changeSetting', {
        key: 'theme',
        value: val
      });
    },
    openAppDownloadPage: function openAppDownloadPage() {
      var downloadUrl = isClient('caky') ? 'https://www.jqinfo.top/app-caky-campus.html' : 'https://www.jqinfo.top/app-campus.html';
      window.open(downloadUrl, '_blank');
    }
  }
};